import React, { Component } from "react";
// import {Link} from "react-router-dom";

import './CompanyDashboard.scss';
import MyContext from '../MyContext.jsx';
import { Link } from "react-router-dom";
import Select from "react-select";
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from "../Loading/Loader";
import { resetScroll } from "../Utility/resetScroll";



class CompanyDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sales_percentage: 0,
      collection_percentage: 0,
      sales_pending: 0,
      executive: '',
      executives: [],
      designations: [],
      designation: '',
      sales_achieved: 0,
      target_achieved: 0,
      sales_achieved_yearly: 0,
      sales_pending: 0,
      sales_percentage: 0,
      sales_target: 0,
      current_month_sales: 0,
      sales_pending: 0,
      primary_sale: 0,
      primary_sale_yearly: 0,
      crm_monthly: 0,
      crm_yearly: 0,
      settlement_monthly: 0,
      settlement_yearly: 0,
      total_outstanding: 0,
      total_overdue: 0,
      sr_monthly: 0,
      sr_yearly: 0,
      sale_return_monthly: 0,
      sale_return_yearly: 0,
      collection_from_tally_yearly: 0,
      collection_from_tally_monthly: 0,
      collection_from_tally_weekly: 0,
      collection_from_tally_weekly_detailed: [],
      collection_from_tally_monthly_detailed: [],
      primary_target: 0,
      primary_achieved: 0,
      primary_percentage: 0,
      primary_pending: 0,
      collectionDetails: [],
      showModal: false,
      division :'',
    }
    this.getDashboardDetails = this.getDashboardDetails.bind(this);
    this.pulltorefresh = this.pulltorefresh.bind(this);
    this.getExecutives = this.getExecutives.bind(this);
    this.getDesignations = this.getDesignations.bind(this);
    this.executiveChange = this.executiveChange.bind(this);
    this.designationChange = this.designationChange.bind(this);
    this.showCollectionDetails = this.showCollectionDetails.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.divisionChange = this.divisionChange.bind(this);


  }

  componentDidMount() {
    this.setState({
      // division: this.context.user_details.division
    }, () => {
      this.getDashboardDetails();
    });
    requestAnimationFrame(() => {
      resetScroll('.company_data_container');
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.showModal !== prevState.showModal) {
      if (this.state.showModal) {
        document.body.style.overflow = "hidden"; // Disable background scrolling
      } else {
        document.body.style.overflow = "auto"; // Enable background scrolling
      }
    }
  }
  divisionChange(option) {
    // if (option.value == this.context.user_details.division.value) {
    //   return;
    // }
    this.setState({
      division: option
    }, () => {
      this.getDashboardDetails();
    });

  }
  getDesignations() {
    var obj_this = this;
    obj_this.context.loading(1);
    const url = `${process.env.REACT_APP_SSS}/api/getDesignations`;
    $.ajax({
      url: url,
      data: {
        sid: this.context.user_details.sid
      },
      type: "POST"
    }).done(function (return_data) {
      console.log(return_data);
      if (return_data.status == "success") {
        obj_this.setState({
          designations: return_data.designations,
        });
      } else {
        obj_this.props.history.replace("/");
      }
      // obj_this.context.loading(0);

    }).fail(function () {
      alert("Network error");
    });
  }
  getExecutives() {
    var obj_this = this;
    if (!obj_this.state.designation.label)
      return;

    obj_this.context.loading(1);
    const url = `${process.env.REACT_APP_SSS}/api/getDesignationWiseExecutives`;
    $.ajax({
      url: url,
      data: {
        sid: this.context.user_details.sid,
        designation_id: obj_this.state.designation.value
      },
      type: "POST"
    }).done(function (return_data) {
      console.log(return_data);
      if (return_data.status == "success") {
        obj_this.setState({
          executives: return_data.executives,
        });
      } else {
        obj_this.props.history.replace("/");
      }
      obj_this.context.loading(0);

    }).fail(function () {
      alert("Network error");
    });
  }

  getDashboardDetails() {
    let url = '';
    if(this.state.division){
      url = `${process.env.REACT_APP_SSS}/api/getDashboardDetails`;
    }else{
      url = `${process.env.REACT_APP_SSS}/api/getTotalCompanyData`;
    }
    var obj_this = this;
    obj_this.context.loading(1);
    $.ajax({
      url: url,
      data: {
        sid: this.context.user_details.sid,
        // executive: this.state.executive.value,
        division_id: this.state.division?.value
      },
      type: "POST"
    }).done(function (return_data) {
      console.log(return_data);
      if (return_data.status == "success") {
        let companydata = return_data.data;
        obj_this.setState({
          sales_achieved: companydata.sales_achieved ?? '',
          target_achieved: companydata.target_achieved ?? '',
          sales_achieved_yearly: companydata.sales_achieved_yearly ?? '',
          sales_pending: companydata.sales_pending ?? '',
          sales_percentage: companydata.sales_percentage ?? '',
          sales_pending_percentage: companydata.sales_pending_percentage ?? '',
          sales_target: companydata.sales_target ?? '',
          current_month_sales: companydata.sales_achieved ?? '',
          sales_pending: companydata.sales_pending ?? '',
          // location: companydata.location_mapped?companydata.location_mapped[0] ?? '' : '',
          primary_sale: companydata.primary_sale ?? '',
          primary_sale_yearly: companydata.primary_sale_yearly ?? '',
          crm_monthly: companydata.crm_monthly ?? '',
          crm_yearly: companydata.crm_yearly ?? '',
          settlement_monthly: companydata.settlement_monthly ?? '',
          settlement_yearly: companydata.settlement_yearly ?? '',
          total_outstanding: companydata.total_outstanding ?? '',
          total_overdue: companydata.total_overdue ?? '',
          sr_monthly: companydata.sr_monthly ?? '',
          sr_yearly: companydata.sr_yearly ?? '',
          sale_return_monthly: companydata.sale_return_monthly ?? '',
          sale_return_yearly: companydata.sale_return_yearly,
          collection_from_tally_yearly: companydata.collection_from_tally_yearly,
          collection_from_tally_monthly: companydata.collection_from_tally_monthly,
          collection_from_tally_weekly: companydata.collection_from_tally_weekly,
          primary_target: companydata.primary_target ?? '',
          primary_achieved: companydata.primary_achieved ?? '',
          primary_percentage: companydata.primary_percentage ?? '',
          primary_pending_percentage : companydata.primary_pending_percentage ?? '',
          primary_pending: companydata.primary_pending ?? '',
          collection_from_tally_weekly_detailed: companydata.collection_from_tally_weekly_detailed,
          collection_from_tally_monthly_detailed: companydata.collection_from_tally_monthly_detailed,


        })
        obj_this.context.loading(0);
      }
      else if (return_data.status == "fail") {
        obj_this.context.loading(0);
        alert("You are not authorized to access");
      }
      else {
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function () {
      obj_this.context.loading(0);
      alert("Network error");
    });
  }

  designationChange(option) {
    var obj_this = this;
    obj_this.setState({
      designation: option,
      executive: ''
    }, () => {
      obj_this.getExecutives();
    });

  }
  executiveChange(option) {
    if (option.value == this.state.executive.value) {
      return;
    }
    this.setState({
      executive: option
    })
    var obj_this = this;
    obj_this.context.loading(1);
    const url = `${process.env.REACT_APP_SSS}/api/getDashboardDetails`;

    $.ajax({
      url: url,
      data: {
        sid: this.context.user_details.sid,
        executive: option.value
      },
      type: "POST"
    }).done(function (return_data) {
      console.log(return_data);
      // return;
      if (return_data.status == "success") {
        obj_this.setState({
          sales_achieved: return_data.sales_achieved ?? '',
          target_achieved: return_data.target_achieved ?? '',
          sales_achieved_yearly: return_data.sales_achieved_yearly ?? '',
          sales_pending: return_data.sales_pending ?? '',
          sales_percentage: return_data.sales_percentage ?? '',
          sales_target: return_data.sales_target ?? '',
          current_month_sales: return_data.sales_achieved ?? '',
          sales_pending: return_data.sales_pending ?? '',
          location: return_data.location_mapped[0] ?? '',
          primary_sale: return_data.primary_sale ?? '',
          primary_sale_yearly: return_data.primary_sale_yearly ?? '',
          crm_monthly: return_data.crm_monthly ?? '',
          crm_yearly: return_data.crm_yearly ?? '',
          settlement_monthly: return_data.settlement_monthly ?? '',
          settlement_yearly: return_data.settlement_yearly ?? '',
          total_outstanding: return_data.total_outstanding ?? '',
          total_overdue: return_data.total_overdue ?? '',
          sr_monthly: return_data.sr_monthly ?? '',
          sr_yearly: return_data.sr_yearly ?? '',
          sale_return_monthly: return_data.sale_return_monthly ?? '',
          sale_return_yearly: return_data.sale_return_yearly,
          collection_from_tally_yearly: return_data.collection_from_tally_yearly,
          collection_from_tally_monthly: return_data.collection_from_tally_monthly,
          collection_from_tally_weekly: return_data.collection_from_tally_weekly,
          primary_target: return_data.primary_target ?? '',
          primary_achieved: return_data.primary_achieved ?? '',
          primary_percentage: return_data.primary_percentage ?? '',
          primary_pending: return_data.primary_pending ?? '',
          collection_from_tally_weekly_detailed: return_data.collection_from_tally_weekly_detailed,
          collection_from_tally_monthly_detailed: return_data.collection_from_tally_monthly_detailed,

        })
        obj_this.context.loading(0);
      } else {
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function () {
      alert("Network error");
    });
  }
  pulltorefresh() {
    this.setState({
      executive: ''
    })
    this.getDashboardDetails();
  }
  showCollectionDetails(type) {
    // console.log('Show details for:', type);
    var obj_this = this;
    if (type === 'weekly') {
      // console.log(obj_this.state.collection_from_tally_weekly_detailed);
      if (obj_this.state.collection_from_tally_weekly_detailed?.length == 0) {
        alert("No data available");
        return;
      }
      obj_this.setState({
        collectionDetails: obj_this.state.collection_from_tally_weekly_detailed,
        showModal: true
      });
    } else if (type === 'monthly') {
      // console.log(obj_this.state.collection_from_tally_monthly_detailed);
      if (obj_this.state.collection_from_tally_monthly_detailed?.length == 0) {
        alert("No data available");
        return;
      }
      obj_this.setState({
        collectionDetails: obj_this.state.collection_from_tally_monthly_detailed,
        showModal: true
      });
    }
    document.body.style.overflow = "hidden"; // Disable background scrolling
    if (obj_this.state.showModal) {
      document.querySelector('.infinite-scroll-component').style.overflow = 'hidden'; // Disable pull-to-refresh
    } else {
      document.querySelector('.infinite-scroll-component').style.overflow = 'auto'; // Enable pull-to-refresh
    }
  }
  hideModal = () => {
    this.setState({ showModal: false });
  };
  render() {
    return (
      <MyContext.Consumer>
        {context => (
          <div className="company_data_container">
            <div className="header_spacer"></div>
            <div className="page_header">
              <Link className="back_button" to="/dashboard"><i className="fas fa-arrow-left"></i></Link>
              <div className="page_title">Company Dashboard</div>
            </div>
            <div className="company_data_dashboard_container">
              <div className="list_blocks_container">
                <InfiniteScroll
                  dataLength={1}
                  refreshFunction={this.pulltorefresh}
                  pullDownToRefresh={this.state.showModal ? false : true}
                  pullDownToRefreshThreshold={300}
                  pullDownToRefreshContent={
                    <h3 style={{ textAlign: 'center', top: '50px' }}>&#8595; Pull down to refresh</h3>
                  }
                  releaseToRefreshContent={<Loader />}
                >
                  <div className="lists_container graph_block">

                    {/* User Info & Dropdowns */}
                    <div className="dashboard-header">

                      <div className="dropdowns">
                       
                        <Select className="division_select"
                          options={this.context.user_details.divisions}
                          value={this.state.division}
                          onChange={this.divisionChange}
                          isSearchable={false}
                          placeholder="Select Division..."
                        />
                      </div>
                    </div>

                    {/* Date */}
                    <div className="current_month">
                      {new Date().toLocaleString('default', { month: 'long', day: 'numeric', year: 'numeric' })}
                    </div>

                    {/* Primary Target Card */}
                    <div className="card">
                      <div className="card-title">
                        <i className="fas fa-bullseye"></i> Primary Target
                      </div>
                      <table className="card-table">
                        <thead>
                          <tr>
                            <th>Target</th>
                            <th>Achieved</th>
                            <th>Pending</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{this.state.primary_target} <i className="fas fa-rupee-sign"></i></td>
                            <td>
                              {this.state.primary_percentage}%<br /><br />
                              {this.state.primary_achieved} <i className="fas fa-rupee-sign"></i>
                            </td>
                            <td>
                              {this.state.primary_pending_percentage}%<br /><br />
                              {parseFloat(this.state.primary_pending)} <i className="fas fa-rupee-sign"></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Secondary Target Card */}
                    <div className="card">
                      <div className="card-title">
                        <i className="fas fa-bullseye"></i> Secondary Target
                      </div>
                      <table className="card-table">
                        <thead>
                          <tr>
                            <th>Target</th>
                            <th>Achieved</th>
                            <th>Pending</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{this.state.sales_target} <i className="fas fa-rupee-sign"></i></td>
                            <td>
                              {this.state.sales_percentage}%<br /> <br />
                              {this.state.target_achieved} <i className="fas fa-rupee-sign"></i>
                            </td>
                            <td>
                              {this.state.sales_pending_percentage}%<br /> <br />
                              {parseFloat(this.state.sales_pending)} <i className="fas fa-rupee-sign"></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Outstanding Card */}
                    <div className="card">
                      <div className="card-title">
                        <i className="fas fa-wallet"></i> Outstanding
                      </div>
                      <table className="card-table">
                        <tbody>
                          <tr>
                            <td>Total Outstanding</td>
                            <td>{this.state.total_outstanding} <i className="fas fa-rupee-sign"></i></td>
                          </tr>
                          <tr>
                            <td>Total Overdue</td>
                            <td>{this.state.total_overdue} <i className="fas fa-rupee-sign"></i></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Sales Graph Card */}
                    <div className="card">
                      <div className="card-title">
                        <i className="fas fa-chart-bar"></i> Sales Graph
                      </div>
                      <table className="card-table">
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th>Current Month</th>
                            <th>Total Yearly</th>
                            <th>% vs Sec.</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Primary</td>
                            <td>{this.state.primary_sale} <i className="fas fa-rupee-sign"></i></td>
                            <td>{this.state.primary_sale_yearly} <i className="fas fa-rupee-sign"></i></td>
                            <td>{this.state.primary_sale && this.state.sales_achieved  && this.state.sales_achieved >0
                              ? `${(this.state.primary_sale / this.state.sales_achieved * 100).toFixed(0)}%`
                              : '-'} </td>
                          </tr>
                          <tr>
                            <td>Secondary</td>
                            <td>{this.state.sales_achieved} <i className="fas fa-rupee-sign"></i></td>
                            <td>{this.state.sales_achieved_yearly} <i className="fas fa-rupee-sign"></i></td>
                            <td>-</td>
                          </tr>
                          <tr>
                            <td>CRM</td>
                            <td>{this.state.crm_monthly} <i className="fas fa-rupee-sign"></i></td>
                            <td>{this.state.crm_yearly} <i className="fas fa-rupee-sign"></i></td>
                            <td>{this.state.crm_monthly && this.state.sales_achieved  && this.state.sales_achieved >0
                              ? `${(this.state.crm_monthly / this.state.sales_achieved * 100).toFixed(0)}%`
                              : '-'} </td>
                          </tr>
                          <tr>
                            <td>Settlement</td>
                            <td>{this.state.settlement_monthly} <i className="fas fa-rupee-sign"></i></td>
                            <td>{this.state.settlement_yearly} <i className="fas fa-rupee-sign"></i></td>
                            <td>{this.state.settlement_monthly && this.state.sales_achieved  && this.state.sales_achieved >0
                              ? `${(this.state.settlement_monthly / this.state.sales_achieved * 100).toFixed(0)}%`
                              : '-'} </td>
                          </tr>
                          <tr>
                            <td>Sample</td>
                            <td>{this.state.sr_monthly} <i className="fas fa-rupee-sign"></i></td>
                            <td>{this.state.sr_yearly} <i className="fas fa-rupee-sign"></i></td>
                            <td>{this.state.sr_monthly && this.state.sales_achieved  && this.state.sales_achieved >0
                              ? `${(this.state.sr_monthly / this.state.sales_achieved * 100).toFixed(0)}%`
                              : '-'} </td>
                          </tr>
                          <tr>
                            <td>Expiry</td>
                            <td>{this.state.sale_return_monthly} <i className="fas fa-rupee-sign"></i></td>
                            <td>{this.state.sale_return_yearly} <i className="fas fa-rupee-sign"></i></td>
                             <td>{this.state.sale_return_monthly && this.state.sales_achieved  && this.state.sales_achieved >0
                              ? `${(this.state.sale_return_monthly / this.state.sales_achieved * 100).toFixed(0)}%`
                              : '-'} </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Collection - Tally Card */}
                    <div className="card">
                      <div className="card-title">
                        <i className="fas fa-list"></i> Collection - Tally
                      </div>
                      <table className="card-table">
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th>Weekly</th>
                            <th>Monthly</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Collection - Tally</td>
                            <td>
                              <div className="button-style">
                                <span>
                                  {parseFloat(this.state.collection_from_tally_weekly)} <i className="fas fa-rupee-sign"></i>
                                </span>
                                <button className="list-button" onClick={() => this.showCollectionDetails('weekly')}>
                                  <i className="fa fa-list"></i>
                                </button>
                              </div>
                            </td>
                            <td>
                              <div className="button-style">
                                <span>
                                  {parseFloat(this.state.collection_from_tally_monthly)} <i className="fas fa-rupee-sign"></i>
                                </span>
                                <button className="list-button" onClick={() => this.showCollectionDetails('monthly')}>
                                  <i className="fa fa-list"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Price List Button */}
                    {/* <div className="price_list_container">
                      <Link to='/pricelist'>
                        <button className="pushable">
                          Price List <i className="fa fa-shopping-cart" aria-hidden="true"></i>
                        </button>
                      </Link>
                    </div> */}
                  </div>
                </InfiniteScroll>

                {/* Modal */}
                {this.state.showModal && this.state.collectionDetails?.length ? (
                  <div className="modal" onClick={() => this.hideModal()}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                      <div className="modal-header">
                        <h2>Collection Details</h2>
                        <button className="modal-close" aria-label="Close" onClick={() => this.hideModal()}>
                          <i className="fas fa-times"></i>
                        </button>
                      </div>
                      <table className="collection-details-table">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Customer Name</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.collectionDetails.map((detail, index) => (
                            <tr key={index}>
                              <td>{new Date(detail.date).toLocaleDateString()}</td>
                              <td>{detail.customer_name}</td>
                              <td>{detail.amount} <i className="fas fa-rupee-sign"></i></td>
                            </tr>
                          ))}
                          <tr>
                            <td colSpan={2}>Total</td>
                            <td style={{ textAlign: "right" }}>
                              {parseFloat(this.state.collectionDetails.reduce((sum, detail) => sum + parseFloat(detail.amount), 0)).toFixed(0)} <i className="fas fa-rupee-sign"></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="bottom_navbar_spacer"></div>
          </div>
        )}
      </MyContext.Consumer>
    )
  }
}

export default CompanyDashboard;
CompanyDashboard.contextType = MyContext;
